import { defineAsyncComponent, toRaw } from "vue";
import type { AuthorizationRuleForGatingInput } from "../use-gating-rule-conversion";
import type {
  CriterionApplyContext,
  GatingCriterionTypeDefinition,
} from "./gating-criterion-type";
import { GatingStrategyType } from "../strategies/gating-strategy";

export const tokenCriterionType: GatingCriterionTypeDefinition = {
  presetId: "token_holders",
  classificationKey: GatingStrategyType.token,
  capabilityKey: "canUseTokenGating",

  labelKey: "channel.gating.builder.presets.tokenHolders.label",
  descriptionKey: "channel.gating.builder.presets.tokenHolders.description",
  icon: "material-symbols:token-outline",
  columnHeaderKey: "channel.gating.builder.featureRows.minTokenNeeded",

  hasCriterion(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.web_three_token_criterion;
  },

  isGated(rule: AuthorizationRuleForGatingInput): boolean {
    return !!rule.web_three_token_criterion;
  },

  applyDefaults(
    rule: AuthorizationRuleForGatingInput,
    context: CriterionApplyContext,
  ): void {
    rule.web_three_token_criterion = {
      min_tokens: 0,
      permission_mask: rule.significant_permissions_mask,
      permission_mask_level: 0,
      web_three_erc_twenty_token_address: context.defaultTokenAddress ?? "",
    };
  },

  clearCriterion(rule: AuthorizationRuleForGatingInput): void {
    rule.web_three_token_criterion = undefined;
  },

  copyCriterion(
    source: AuthorizationRuleForGatingInput,
    target: AuthorizationRuleForGatingInput,
  ): void {
    target.web_three_token_criterion = source.web_three_token_criterion
      ? structuredClone(toRaw(source.web_three_token_criterion))
      : undefined;
  },

  criterionEquals(
    a: AuthorizationRuleForGatingInput,
    b: AuthorizationRuleForGatingInput,
  ): boolean {
    return (
      JSON.stringify(a.web_three_token_criterion) ===
      JSON.stringify(b.web_three_token_criterion)
    );
  },

  serializeCriterion(rule: AuthorizationRuleForGatingInput): unknown {
    return rule.web_three_token_criterion;
  },

  expandedLayout: "inline",

  indeterminatePlaceholder: defineAsyncComponent(
    () => import("../builder/components/token-indeterminate-placeholder.vue"),
  ),

  expandedValueEditor: defineAsyncComponent(
    () => import("../builder/components/token-expanded-editor.vue"),
  ),
};
